import Api from "@/services/Api";

export default {
  view(userId) {
    return Api().get("users/" + userId);
  },
  update(form, userId) {
    return Api().put("users/" + userId, form);
  }
};
